import { FormNumber } from 'eone-ui/forms/form-number';
import type { SCFormFieldProps } from './form_field';
import { SCFormField } from './form_field';
import { handleFieldUp } from './helper';
import './styles.css';

interface SCFormFieldNumberProps extends SCFormFieldProps {
  onChange?: (value: number | null) => void;
  onBlur?: (value: number | null) => void;
}

const SCFormFieldNumber = ({
  label,
  name,
  max,
  min,
  required,
  disabled,
  rules,
  visible,
  onChange,
  onBlur,
  ...rest
}: SCFormFieldNumberProps) => {
  return (
    <SCFormField
      visible={visible}
      label={label}
      name={name}
      disabled={disabled}
      required={required}
      rules={rules}
    >
      {({ field, extraProps }) => {
        const fieldUp = handleFieldUp(field, { disabledRef: true });
        return (
          <FormNumber
            {...fieldUp}
            OnChange={(newValue) => {
              fieldUp.OnChange(newValue);
              onChange?.(newValue);
            }}
            OnBlur={(newValue) => {
              // The input clamps to [min, max] on blur, but react-hook-form's field.onBlur
              // ignores its argument, so commit the clamped value explicitly via onChange and
              // then mark the field touched. Without this the clamped/normalized value never
              // reaches the form (e.g. typing "3" would stay "3" instead of snapping to the min).
              field.onChange(newValue);
              field.onBlur();
              onBlur?.(newValue);
            }}
            Label={label}
            Required={required}
            ShowRequiredIndicator={required}
            ReadOnly={field.disabled}
            MaximumValue={max}
            MinimumValue={min}
            {...rest}
            {...extraProps}
          />
        );
      }}
    </SCFormField>
  );
};

export { SCFormFieldNumber };
export type { SCFormFieldNumberProps, SCFormFieldProps };
